"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4766],{

/***/ 24766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ store_PaypalCancelledModal; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/library/ModalWithButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function visibilityContainer(v) {
    return Cn_bs/* make */.S([
        v ? "visible animate__animated animate__fadeIn animate__faster" : "invisible"
    ]);
}
function visibilityModal(v) {
    return Cn_bs/* make */.S([
        v ? "visible animate__animated animate__fadeIn animate__faster" : "invisible"
    ]);
}
function ModalWithButton(props) {
    var visible = props.visible;
    var onButtonClick = props.onButtonClick;
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx("div", {
            children: jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("h2", {
                        children: util_bs/* ReactStuff.s */.p_.s(props.heading),
                        className: "text-2xl text-center font-black md:leading-loose text-dark-gray"
                    }),
                    jsx_runtime.jsx("p", {
                        children: util_bs/* ReactStuff.s */.p_.s(props.text),
                        className: "text-sm md:text-base leading-normal font-thin mt-8 mb-10 text-center"
                    }),
                    jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s(props.button),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "w-24 text-base md:w-32 h-10 md:h-12 mr-3 md:text-lg font-bold"
                            ]),
                            onClick: function onClick(e) {
                                e.preventDefault();
                                curry._1(onButtonClick, undefined);
                            }
                        }),
                        className: "inline-flex justify-center"
                    }),
                    jsx_runtime.jsx("span", {
                        children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "times"
                            ]
                        }),
                        className: "absolute flex items-center justify-center -mt-3 -mr-3 right-0 top-0 h-8 w-8 overflow-visible rounded-full bg-prezzee-red fill-current text-white cursor-pointer",
                        onClick: function onClick(e) {
                            e.preventDefault();
                            curry._1(onButtonClick, undefined);
                        }
                    })
                ],
                className: Cn_bs/* make */.S([
                    "text-gray-800 fixed shadow-inner max-w-md relative bottom-0 inset-x-0 m-auto px-4 py-8 bg-white w-10/12 md:w-full flex flex-col rounded-md",
                    visibilityModal(visible)
                ]),
                onClick: function onClick(e) {
                    e.preventDefault();
                }
            }),
            className: Cn_bs/* make */.S([
                "fixed inset-0 flex bg-smoke-light",
                visibilityContainer(visible)
            ]),
            style: {
                zIndex: "1000"
            }
        })
    });
}
var make = ModalWithButton;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./src/reducers/ProductPageReducer.ts
var ProductPageReducer = __webpack_require__(83574);
// EXTERNAL MODULE: ./src/contexts/ProductPageContext.tsx
var ProductPageContext = __webpack_require__(16029);
;// CONCATENATED MODULE: ./src/components/pages/store/PaypalCancelledModal.tsx




var PaypalCancelledModal = function() {
    var ref = (0,ProductPageContext/* useProduct */.i)() || {}, dispatch = ref.dispatch, state = ref.state;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(make, {
        visible: state.paypal == ProductPageReducer/* PaypalStatus.Cancelled */.Be.Cancelled,
        heading: "Transaction Cancelled",
        text: "Your PayPal transaction was cancelled. Your PayPal account was not charged.",
        button: "OK",
        onButtonClick: function() {
            dispatch({
                type: ProductPageReducer/* ActionType.PaypalIdle */.Us.PaypalIdle
            });
        }
    });
};
/* harmony default export */ var store_PaypalCancelledModal = (PaypalCancelledModal);


/***/ })

}]);